import { useQuery } from '@tanstack/react-query';

import { api } from '@/api/client';
import type { Medicine } from '@/api/types';

export interface ReorderSuggestion {
  medicine: Medicine;
  totalSoldLast30Days: number;
  avgDailySales: number;
  suggestedOrderQty: number;
}

export function useReorderSuggestions(enabled = true) {
  return useQuery({
    queryKey: ['medicines', 'reorder-suggestions'],
    queryFn: () => api.get<ReorderSuggestion[]>('/api/medicines/reorder-suggestions'),
    enabled,
    staleTime: 60_000,
  });
}
